<template>
	<div class="special" v-if="isBackup">
		<i class="sk-icon-scroll-regular special-icon" alt="Backup"></i>
		<div style="special-description">
			<h3 class="special-title">Some Items Have Switched!</h3>
			<h4 class="special-subtitle">Based on restaurant availability</h4>
		</div>
	</div>
</template>

<script>
export default {
	name: "BackupBanner",
	computed: {
		isBackup() {
			return this.$store.state.backup_mode
		}
	}
}
</script>